import { type CheckDepthTier, TIER_PRICES_PENCE } from '@nestjs-boilerplate/types';

export interface TierFeature {
  text: string;
  included: boolean;
}

export interface TierConfig {
  id: CheckDepthTier;
  name: string;
  price: string;
  priceInPence: number;
  description: string;
  features: TierFeature[];
  includesFrom?: CheckDepthTier;
}

export const TIER_CONFIGS: Record<CheckDepthTier, TierConfig> = {
  basic: {
    id: 'basic',
    name: 'Basic',
    price: '£2.50',
    priceInPence: TIER_PRICES_PENCE.basic,
    description: 'Run selected checks with clear match/no match results',
    features: [
      { text: 'Run selected screening checks', included: true },
      { text: 'Match found or clear result per check', included: true },
      { text: 'Summary risk level indication', included: true },
    ],
  },
  standard: {
    id: 'standard',
    name: 'Standard',
    price: '£10.00',
    priceInPence: TIER_PRICES_PENCE.standard,
    description: 'Comprehensive screening with detailed reporting',
    includesFrom: 'basic',
    features: [{ text: 'Match Risk Report with detailed findings', included: true }],
  },
  enhanced: {
    id: 'enhanced',
    name: 'Enhanced',
    price: '£25.00',
    priceInPence: TIER_PRICES_PENCE.enhanced,
    description: 'Deep analysis of all articles with AI confidence scoring',
    includesFrom: 'standard',
    features: [
      { text: 'Enhanced Due Diligence', included: true },
      { text: 'Full article extraction', included: true },
      { text: 'AI confidence scoring', included: true },
    ],
  },
};

export const TIER_ORDER: CheckDepthTier[] = ['basic', 'standard', 'enhanced'];
